<template>
    <confirm text="去选择支付方式？" v-model="showPayConfirm" @on-sure="payConfirm"></confirm>
</template>

<script>
    import payService from 'pay.service'
    import Confirm from 'Confirm'

    export default {
        components: {
            Confirm
        },
        props: {
            value: Boolean,
        },
        data() {
            return {
                appId: '',
                showPayConfirm: this.value,
            }
        },
        methods: {
            //调用微信接口，跳转界面获取用户code
            payConfirm() {
                var getCodeParams = {
                    appId: this.appId
                }
                //判断是否为天府云渠道
                if (localStorage.channel === 'TFY' || localStorage.channel === 'TFTB' || localStorage.channel === 'TFRYB') {
                    this.$router.push('pay');
                    return;
                }
                payService.getUserCode(getCodeParams);
            },
        },
        watch: {
            value(val) {
                if (!val) {
                    return;
                }
                //获取医院支付信息
                payService.getHosAppId().then((res) => {
                    if (res.resultCode === this.constant.RESULT_SUCCESS) {
                        this.appId = res.data.appId;
                        this.showPayConfirm = val
                    } else {
                        this.$utils.alert(res.resultMsg)
                    }
                })
            },
            showPayConfirm(val) {
                this.$emit('input', val)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// PayConfirm.vue?277b2856